import React, { useState, useEffect, useRef } from 'react';
import ProtectedRoute from '../../routes/protected';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Avatar } from 'primereact/avatar';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/pt-br';
import NameInitials from '../../helpers/nameInitials';
import performanceService from '../../services/data/performance.service';
import employeeService from '../../services/data/employee.service';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import FormGiveFeedback from '../../components/performance/forms/formGiveFeedback';

moment.locale('pt-br');

export default function FeedbackPending() {
    const toast = useRef(null);
    const navigate = useNavigate();
    const offCanvasRef = useRef();

    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [myEmployeeId, setMyEmployeeId] = useState(null);

    useEffect(() => {
        loadRequests();
        employeeService.getUserEmployee().then((emp) => setMyEmployeeId(emp.id)).catch(() => {});
    }, []);

    function loadRequests() {
        setLoading(true);
        performanceService.listFeedbackRequestsPending(1).then((data) => {
            setRequests(data.results || []);
        }).catch(() => {
            toast.current?.show({ severity: 'warn', summary: 'Ops', detail: 'Erro ao carregar solicitações', life: 3000 });
        }).finally(() => setLoading(false));
    }

    function openRespond(req) {
        setSelectedRequest(req);
        const canvas = new bootstrap.Offcanvas(offCanvasRef.current);
        canvas.show();
    }

    function hideCanvas() {
        const instance = bootstrap.Offcanvas.getInstance(offCanvasRef.current);
        instance?.hide();
    }

    function onSuccess() {
        hideCanvas();
        loadRequests();
        toast.current?.show({ severity: 'success', summary: 'Sucesso', detail: 'Feedback enviado!', life: 3000 });
    }

    return (
        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />

            <div className="container py-4 formMarginBottom">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <button className="btn btn-link p-0 text-decoration-none text-muted" onClick={() => navigate(myEmployeeId ? `/career/feedback/${myEmployeeId}/` : -1)}>
                        <FontAwesomeIcon icon={solid('arrow-left')} />
                    </button>
                    <div>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={solid('bell')} className="me-2 text-warning" />
                            Feedbacks Pendentes
                        </h4>
                        <p className="text-muted small mb-0">Solicitações de feedback aguardando sua resposta</p>
                    </div>
                </div>
                
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" />
                    </div>
                ) : requests.length === 0 ? (
                    <div className="text-center py-5 text-muted">
                        <FontAwesomeIcon icon={solid('check-circle')} size="3x" className="text-success mb-3" />
                        <h5 className="fw-bold">Tudo em dia!</h5>
                        <p className="small">Você não tem nenhuma solicitação de feedback pendente.</p>
                    </div>
                ) : (
                    <div className="row g-3">
                        {requests.map((req) => (
                            <div key={req.id} className="col-12 col-md-6 col-xl-4">
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            <Avatar
                                                image={req.created_by_photo}
                                                label={!req.created_by_photo ? NameInitials(req.created_by_name) : undefined}
                                                shape="circle"
                                                size="large"
                                                style={{ backgroundColor: '#dee2e6', color: '#495057', flexShrink: 0 }}
                                            />
                                            <div>
                                                <p className="fw-semibold mb-0 small">{req.created_by_name}</p>
                                                <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>
                                                    Solicitou {moment(req.created).fromNow()}
                                                </p>
                                            </div>
                                        </div>

                                        <h6 className="fw-bold mb-1">{req.title}</h6>
                                        <p className="text-muted small mb-3" dangerouslySetInnerHTML={{ __html: req.description }} />

                                        <button
                                            className="btn btn-success btn-sm w-100"
                                            onClick={() => openRespond(req)}
                                        >
                                            <FontAwesomeIcon icon={solid('reply')} className="me-1" />
                                            Responder
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                
            </div>

            {/* Offcanvas: Responder */}
            <div className="offcanvas offcanvas-end" tabIndex="-1" ref={offCanvasRef}>
                <div className="offcanvas-header border-bottom">
                    <h6 className="offcanvas-title fw-bold">
                        <FontAwesomeIcon icon={solid('reply')} className="me-2 text-success" />
                        Responder Feedback
                    </h6>
                    <button type="button" className="btn-close" onClick={hideCanvas} />
                </div>
                <div className="offcanvas-body">
                    {selectedRequest && (
                        <FormGiveFeedback
                            employee={{ id: selectedRequest.created_by }}
                            feedbackRequest={selectedRequest}
                            onSuccess={onSuccess}
                            onCancel={hideCanvas}
                        />
                    )}
                </div>
            </div>
        </ProtectedRoute>
    );
}
